<template>
  <div>
    <template v-for="(item, index) in categorias">
      <v-chip small outlined :key="index" v-if="index < 3" class="mr-1">
        {{item.descricao}}
      </v-chip>
    </template>

    <v-chip small outlined v-show="categorias.length > 3">
      + {{ categorias.length - 3 }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "ColunaComCategoriasMapeadas",
  props: {
    categorias: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
